<template>
  <template-layout
    :breadCrumbList="breadcrumbComputed"
    v-if="familyInformation"
  >
    <div class="py-12 px-4">
      <nav class="mb-2">
        <h1 class="text-2xl text-theme-1">
          ข้อมูลครอบครัว
        </h1>
      </nav>
      <div class="w-1/6 h-1/6 mx-auto" v-if="familyInformationLoading">
        <LoadingIcon icon="oval" class="w-8 h-8 text-white" />
      </div>
      <div class="grid grid-cols-2 gap-6" v-else>
        <div class="col-span-2">
          <Infomation
            :familyProfile="true"
            :information="familyInformation"
            @show-edit-modal="handleclickEditFamily"
          />
        </div>
        <div class="h-auto col-span-2 lg:col-span-2">
          <CardLayout :showHeaderButton="false" headerText="สถานะทางการเงิน (ต่อเดือน)">
            <div class="flex items-center h-full">
              <DonutChart
                :height="120"
                :seriesData="seriesDataComputed"
                :chartLabel="['รายได้', 'เงินออม', 'รายจ่าย', 'หนี้สิน']"
                :totalData="totalAmountComputed"
                :layout="{
                  padding:{
                    right: 130
                  }
                }"
                :paddingLayout="130"
              />
            </div>
          </CardLayout>
        </div>
        <div class="h-auto col-span-2 lg:col-span-2">
          <CardLayout>
            <template v-slot:header>
              <div>
                <h4 class="text-theme-37 font-semibold inline-block">
                  แผนผังครอบครัว
                </h4>
              </div>
              <button
                class="btn btn-primary"
                @click="handleClickEditFamilyTree"
                v-if="getAllowActionByCurrRole('edit-family')"
              >
                <Edit2Icon class="h-3 w-3 mr-2" />
                แก้ไข
              </button>
            </template>
            <ModalLayout
              id="edit-family-modal"
              v-model="editFamilyTree"
              class="overflow-y-hidden"
              manual-hide
            >
              <div class="family-modal-height">
                <div class="flex justify-between items-center mb-4">
                  <h2 class="text-base mr-auto font-bold leading-none mb-0">
                    แก้ไขแผนผังครอบครัว
                  </h2>
                </div>
                <div class="edit-famtree-height" v-if="!editFamilyTreeLoading">
                  <FamilyTree
                    :edit="true"
                    id="edit-familytree"
                    :tree-data="tempFamilyTreeData"
                    :relation-data="tempRelationTreeData"
                    :member="familyInformation.memberinfo.member"
                    @onTreeDataChange="handleUpdateTreeData"
                    @onRelationDataChange="handleUpdateRelationTreeData"
                  />
                </div>
                <LoadingIcon v-else icon="oval" class="w-8 h-8 text-white" />
              </div>
              <template v-slot:btn>
                <div
                  class="flex justify-between items-center px-4 md:px-10 py-3"
                >
                  <button
                    class="btn btn-secondary"
                    @click="confirmResetTreeData"
                  >
                    ล้างข้อมูล
                  </button>
                  <div>
                    <button
                      class="btn btn-secondary mr-2"
                      @click="confirmCancelEditFamilyTree"
                    >
                      ยกเลิก
                    </button>
                    <button
                      class="btn btn-primary"
                      @click="confirmSaveFamilyTree"
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              </template>
            </ModalLayout>
            <div v-if="!FamilyTreeLoading">
              <div
                class="alert alert-warning-soft show flex items-center mb-2"
                role="alert"
                v-if="isMemberUpdate"
              >
                <AlertCircleIcon class="w-6 h-6 mr-2" />
                ข้อมูลสมาชิกมีการเปลี่ยนแปลง
              </div>
              <FamilyTree
                :edit="false"
                id="view-familytree"
                :tree-data="familyTreeData"
                :relation-data="relationTreeData"
              />
            </div>
            <LoadingIcon v-else icon="oval" class="w-8 h-8 text-white" />
          </CardLayout>
        </div>
        <!-- <div class="col-span-2">
          <CardLayout headerText="ทรัพย์สิน" :showHeaderButton="false">
            <div class="flex flex-wrap justify-start items-start">
              <CustomAccordion
                class="w-full md:w-5/12 lg:w-1/5 my-6"
                headerText="ที่ดิน"
                :detail="firstSubSin"
              />
              <CustomAccordion
                class="w-full md:w-5/12 lg:w-1/5 my-6"
                headerText="สัตว์เศรษฐกิจ"
                :detail="secondSubSin"
              />
              <CustomAccordion
                class="w-full md:w-5/12 lg:w-1/5 my-6"
                headerText="ทอง"
                :detail="thridSubSin"
              />
              <CustomAccordion
                class="w-full md:w-5/12 lg:w-1/5 my-6"
                headerText="สิ่งปลูกสร้าง"
                :detail="forthSubSin"
              />
            </div>
          </CardLayout>
        </div> -->
        <div class="col-span-2">
          <CardLayout
            headerText="ครอบครัว"
            headerButtonText="+ เพิ่มสมาชิก"
            class="family-member"
            @click-header-button="addMember"
            :showHeaderButton="getAllowActionByCurrRole('create-member')"
          >
            <!-- <div class="">
              <div class="flex justify-end items-center">
                <p class="inline mr-2 mt-2">
                  การแสดงผล :
                </p>
                <RadioCustomButton
                  class="mt-2"
                  name="member-layout"
                  first-option-id="table-layout"
                  second-option-id="card-layout"
                  first-option-value="ตาราง"
                  second-option-value="การ์ด"
                  v-model="layout"
                  :unCheckAbility="false"
                />
              </div>
              <div class="flex flex-wrap">
                <MemberCard
                  v-show="layout === 'การ์ด'"
                  v-for="index in 6"
                  :key="index"
                  class="m-2"
                />
              </div>
            </div> -->
            <MemberDatatable
              :data-array="dataArray"
              v-show="layout !== 'การ์ด'"
              @update-table="getFamilyInformation"
            />
          </CardLayout>
        </div>
      </div>
    </div>
    <AddFamilyModal
      :addFamilyModal="addFamilyModal"
      :addressData="familyInformation"
      :editModal="editFamily"
      @modal-value="handleFamilyEdit"
    />
  </template-layout>
</template>

<script setup>
import { ref, watch, onMounted, computed } from "vue";
import Infomation from "../01house-hold/container/Infomation.vue";
import CardLayout from "@/components/profile/layout/CardLayout.vue";
import DonutChart from "@/components/donut-chart/Main.vue";
import RadioCustomButton from "@/components/base/radio-custom-button";
import CustomAccordion from "@/components/base/custom-accordion/index.vue";
import MemberCard from "@/components/profile/MemberCard.vue";
import ModalLayout from "@/components/base/modal-layout/ModalLayout.vue";
import FamilyTree from "@/components/family-tree/index.vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import axios from "axios";
import Swal from "sweetalert2";
import MemberDatatable from "./ProfileDatatable.vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import AddFamilyModal from "@/components/add-family-modal/index.vue";
import { getAllowActionByCurrRole } from "@/utils/get-roles"

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

const TREE_ROOT_NODE = {
  child: "root",
  parent: "",
  hidden: true,
  no_parent: true,
  relationWithParent: "",
};

const isMemberUpdate = ref(false);
const dataForUpdate = ref(null);
const familyInformationLoading = ref(true);
const layout = ref("ตาราง");
const familyInformation = ref(null);
const editFamily = ref(false);
const editFamilyTree = ref(false);
const addFamilyModal = ref(false);
const router = useRouter();
const route = useRoute();
const dataArray = ref([]);
const store = useStore();
const familyTreeData = ref([TREE_ROOT_NODE]);
const relationTreeData = ref([]);
const tempFamilyTreeData = ref([TREE_ROOT_NODE]);
const tempRelationTreeData = ref([]);
const editFamilyTreeLoading = ref(true);
const FamilyTreeLoading = ref(true);

onMounted(async () => {
  await getFamilyInformation();
});

const getFamilyInformation = async () => {
  familyInformationLoading.value = true;
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}family/getFamilySurveyById`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
  const res = await axios
    .post(url, { famId: route.params.famid }, { headers })
    .catch(() =>
      swalCustom.fire({
        icon: "warning",
        text: "ระบบผิดพลาด",
      })
    );
  familyInformationLoading.value = false;
  if (res.status === 200) {
    familyInformation.value = res.data;
    dataArray.value = res.data.memberinfo.member;
    await getTreeData();
  } else {
    swalCustom.fire({
      icon: "warning",
      text: "ระบบผิดพลาด",
    });
  }
};

const prepareDataForCheckUpdate = (data) => {
  const tempData = {};
  data.forEach((item) => {
    tempData[item._id] = item;
  });
  return tempData;
};

const checkMemberUpdate = async (familyMember, dataForCompare) => {
  // isMemberUpdate
  familyMember.forEach((item) => {
    if (dataForCompare[item.child]) {
      for (const key in item.data) {
        if (item.data[key] !== dataForCompare[item.child][key]) {
          isMemberUpdate.value = true;
        }
      }
    }
  });
};

const confirmResetTreeData = async () => {
  const swalRes = await swalCustom.fire({
    html: `<div style="font-size:18px;"><b/>คุณต้องการล้างข้อมูลทั้งหมดใช่หรือไม่</div>`,
    icon: "warning",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ยกเลิก",
    allowOutsideClick: false,
  });
  if (swalRes.isConfirmed) resetTreeData();
};

const resetTreeData = async () => {
  editFamilyTreeLoading.value = true;
  const headmember = await familyInformation.value.memberinfo.member.filter(
    (member) =>
      member._id === familyInformation.value.memberinfo.head_member._id
  )[0];
  const tempHeadMember = {
    name: headmember.name,
    sex: headmember.sex,
    surname: headmember.surname,
    title: headmember.title,
    _id: headmember._id,
  };
  tempFamilyTreeData.value = [
    TREE_ROOT_NODE,
    {
      child: headmember._id,
      parent: "root",
      data: tempHeadMember,
      relationWithParent: "",
      family_head: true,
      sex: headmember.sex ? headmember.sex : "ชาย",
      no_parent: true,
    },
  ];
  tempRelationTreeData.value = [];
  editFamilyTreeLoading.value = false;
};

const getTreeData = async () => {
  FamilyTreeLoading.value = true;
  editFamilyTreeLoading.value = true;
  const familyMember = familyInformation.value.memberinfo.member;

  if (!familyInformation.value.familyTree) {
    const headmember = await familyInformation.value.memberinfo.member.filter(
      (member) =>
        member._id === familyInformation.value.memberinfo.head_member._id
    )[0];
    const tempHeadMember = {
      name: headmember.name,
      sex: headmember.sex,
      surname: headmember.surname,
      title: headmember.title,
      _id: headmember._id,
    };
    familyTreeData.value = [
      TREE_ROOT_NODE,
      {
        child: tempHeadMember._id,
        parent: "root",
        data: tempHeadMember,
        relationWithParent: "",
        family_head: true,
        sex: tempHeadMember.sex ? tempHeadMember.sex : "ชาย",
        no_parent: true,
      },
    ];
    relationTreeData.value = [];
  } else {
    const familyTreeNode = familyInformation.value.familyTree.node;
    dataForUpdate.value = prepareDataForCheckUpdate(familyMember);
    checkMemberUpdate(familyTreeNode, dataForUpdate.value);
    familyTreeData.value = familyTreeNode;
    relationTreeData.value = familyInformation.value.familyTree.relation;
  }
  // familyTreeData.value = [];
  //   relationTreeData.value = [];
  FamilyTreeLoading.value = false;
  editFamilyTreeLoading.value = false;
};

const saveFamilyTree = async () => {
  const token = store.getters["userAuth/getToken"];
  const url = `${process.env.VUE_APP_BASE_API}family/${route.params.famid}`;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": `application/json; charset=utf-8`,
  };
  const update = {
    familyTree: {
      node: familyTreeData.value,
      relation: relationTreeData.value,
    },
  };
  let errorState = false;
  const respond = await axios.put(url, { update }, { headers }).catch(() => {
    errorState = true;
  });
  if (respond.status === 200 && !errorState) {
    getFamilyInformation();
  } else {
    swalCustom.fire({
      html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลไม่สำเร็จกรุณาลองอีกครั้ง</div>`,
      icon: "error",
    });
  }
};

function addMember() {
  router.push({
    name: "add-member",
    params: {
      // hhid: familyInformation.value.hh_id,
      famid: route.params.famid,
    },
    query: {
      hhid: familyInformation.value.hh_id,
    },
  });
}

const handleclickEditFamily = () => {
  editFamily.value = !editFamily.value;
  addFamilyModal.value = !addFamilyModal.value;
};
const handleFamilyEdit = (val) => {
  editFamily.value = false;
  addFamilyModal.value = false;
  if (val == "saved") getFamilyInformation();
};
const breadcrumbComputed = computed(() => {
  let array = [
    {
      name: "ครัวเรือน",
      path: "main-house-hold",
    },
  ];
  if (familyInformation.value.hh_id) {
    array.push({
      name: "ข้อมูลครัวเรือน",
      path: "household-profile",
      param: { hhid: familyInformation.value.hh_id },
    });
  }
  if (familyInformation.value._id) {
    array.push({
      name: "ข้อมูลครอบครัว",
      active: true,
    });
  }
  return array;
});

const confirmSaveFamilyTree = async () => {
  const swalRes = await swalCustom.fire({
    html: `<div style="font-size:18px;"><b/>คุณต้องการบันทึกการเปลี่ยนแปลงข้อมูลใช่หรือไม่</div>`,
    icon: "warning",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ยกเลิก",
    allowOutsideClick: false,
  });
  if (swalRes.isConfirmed) handleFamilySaveEdit();
};

const confirmCancelEditFamilyTree = async () => {
  const swalRes = await swalCustom.fire({
    html: `<div style="font-size:18px;"><b/>คุณต้องการยกเลิกการเปลี่ยนแปลงข้อมูลใช่หรือไม่</div>`,
    icon: "warning",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ยกเลิก",
    allowOutsideClick: false,
  });

  if (swalRes.isConfirmed) handleFamilyCancelEdit();
};

const updateMemberData = () => {
  tempFamilyTreeData.value.forEach((item) => {
    if (dataForUpdate.value[item.child]) {
      for (const key in item.data) {
        item.data[key] = dataForUpdate.value[item.child][key];
        if (key === "sex") {
          item[key] = dataForUpdate.value[item.child][key];
        }
      }
    }
  });
};

const handleFamilySaveEdit = () => {
  // handleClickEditFamilyTree();
  familyTreeData.value = JSON.parse(JSON.stringify(tempFamilyTreeData.value));
  relationTreeData.value = JSON.parse(
    JSON.stringify(tempRelationTreeData.value)
  );
  isMemberUpdate.value = false;
  editFamilyTree.value = false;
  setTimeout(() => {
    saveFamilyTree();
  }, 500);
};

const handleFamilyCancelEdit = () => {
  // handleClickEditFamilyTree();
  editFamilyTree.value = false;
};

const handleClickEditFamilyTree = () => {
  editFamilyTree.value = !editFamilyTree.value;
  tempFamilyTreeData.value = JSON.parse(JSON.stringify(familyTreeData.value));
  tempRelationTreeData.value = JSON.parse(
    JSON.stringify(relationTreeData.value)
  );
  if (isMemberUpdate.value) updateMemberData();
};

const handleUpdateTreeData = (val) => {
  tempFamilyTreeData.value = val;
};
const handleUpdateRelationTreeData = (val) => {
  tempRelationTreeData.value = val;
};
const seriesDataComputed = computed(()=>{
  let result = [0,0,0,0]
  if(familyInformation.value){
    return [familyInformation.value.memberinfo.sum_income, familyInformation.value.memberinfo.sum_saving, familyInformation.value.memberinfo.sum_expenditure, familyInformation.value.memberinfo.sum_debt]
  }
  return result
})
const totalAmountComputed = computed(()=>{
  let result = 0
  if(familyInformation.value){
    return (familyInformation.value.memberinfo.sum_income - familyInformation.value.memberinfo.sum_expenditure - familyInformation.value.memberinfo.sum_saving - familyInformation.value.memberinfo.sum_debt)
  }
  return result
})
</script>

<style lang="scss" scoped>
.family-member {
  min-height: 400px;
}

.family-modal-height {
  height: 70vh;
  @media screen and (max-width: 600px) {
    height: 60vh;
  }
}
.edit-famtree-height {
  height: 95%;
}
</style>
